import React from "react";
import {Col, Row} from "antd";
import Auxiliary from "util/Auxiliary";

const Dashboard = () => {
  return (
    <Auxiliary>
      <Row>
        <Col span={24}>
          <div className="gx-card">
            <div className="gx-card-body">
              Dashboard
            </div>
          </div>
        </Col>
      </Row>
    </Auxiliary>
  );
};

export default Dashboard;
